import Vue from 'vue'
import VueRouter from 'vue-router'
import Agreement from '@/views/Agreement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Agreement
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/privacy/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
